import Jackpot from './Jackpot';
export default Jackpot;